import React from 'react';
import { ExceptionCategory } from './exception-category';

import IconAnrList from 'svg/v2/newcs_dashboard_left_anr_icon_normal.svg';
import IconCrashList from 'svg/v2/newcs_dashboard_left_crash_icon_normal.svg';
import IconErrorList from 'svg/v2/newcs_dashboard_left_error_icon_normal.svg';
import IconAccessList from 'svg/v2/newcs_dashboard_advancedsearch_allrecords_list_lanuch_icon.svg';
import IconOomList from 'svg/v2/newcs_dashboard_advancedsearch_allrecords_list_oom_icon.svg';
import IconJankList from 'svg/v2/newcs_dashboard_left_jank_icon_normal.svg';
import IconHangList from 'svg/v2/newcs_dashboard_left_hang_icon_normal.svg';
// 颜色常量从 exception-category.scss 统一引入，避免在多处散落硬编码色值
import categoryColors from 'styles/exception-category.scss';

export const ExceptionTypeToIcon = {
  [ExceptionCategory.ACCESS]: <IconAccessList style={{height: 16, width: 16, color: '#13c2c2'}} />,
  [ExceptionCategory.VITAL]: <IconCrashList style={{height: 16, width: 16, color: categoryColors.colorCrash}}/>,
  [ExceptionCategory.CRASH]: <IconCrashList style={{height: 16, width: 16, color: categoryColors.colorCrash}}/>,
  [ExceptionCategory.ANR]: <IconAnrList width="16" height="16" viewBox="0 0 20 20" style={{color: categoryColors.colorAnr}}/>,
  [ExceptionCategory.OOM]: <IconOomList style={{height: 16, width: 16, color: categoryColors.colorOom}} />,
  [ExceptionCategory.ERROR]: <IconErrorList width="16" height="16" viewBox="0 0 20 20" style={{color: categoryColors.colorError}} />,
  [ExceptionCategory.JANK]: <IconJankList width="16" height="16" viewBox="0 0 20 20" style={{color: categoryColors.colorJank}} />,
  [ExceptionCategory.HANG]: <IconHangList width="16" height="16" viewBox="0 0 20 20" style={{color: categoryColors.colorHang}} />,
  [ExceptionCategory.METRICKIT_CRASH]: <IconCrashList style={{height: 16, width: 16, color: categoryColors.colorCrash}}/>,
  [ExceptionCategory.METRICKIT_CPU]: <IconErrorList style={{height: 16, width: 16, color: '#c47800'}}/>,
  [ExceptionCategory.METRICKIT_DISK]: <IconErrorList style={{height: 16, width: 16, color: '#0070b8'}}/>,
  [ExceptionCategory.UNKNOWN]: undefined,
};

export const getExceptionIconByType = ({exceptionType, size = 14}) => {
  const iconMap = {
    [ExceptionCategory.ACCESS]: <IconAccessList style={{color: '#13c2c2', height: size, width: size}} />,
    [ExceptionCategory.VITAL]: <IconCrashList style={{color: categoryColors.colorCrash, height: size, width: size}}/>,
    [ExceptionCategory.CRASH]: <IconCrashList style={{color: categoryColors.colorCrash, height: size, width: size}}/>,
    [ExceptionCategory.ANR]: <IconAnrList style={{color: categoryColors.colorAnr, height: size, width: size}}/>,
    [ExceptionCategory.OOM]: <IconOomList style={{color: categoryColors.colorOom, height: size, width: size}} />,
    [ExceptionCategory.ERROR]: <IconErrorList style={{color: categoryColors.colorError, height: size, width: size}} />,
    [ExceptionCategory.JANK]: <IconJankList width={size} height={size} viewBox="0 0 20 20" style={{color: categoryColors.colorJank}} />,
    [ExceptionCategory.HANG]: <IconHangList width={size} height={size} viewBox="0 0 20 20" style={{color: categoryColors.colorHang}} />,
    [ExceptionCategory.METRICKIT_CRASH]: <IconCrashList style={{color: categoryColors.colorCrash, height: size, width: size}}/>,
    [ExceptionCategory.METRICKIT_CPU]: <IconErrorList style={{color: '#c47800', height: size, width: size}}/>,
    [ExceptionCategory.METRICKIT_DISK]: <IconErrorList style={{color: '#0070b8', height: size, width: size}}/>,
  }

  if (!iconMap[exceptionType]) {
    return null;
  }

  return iconMap[exceptionType];
}
